__turbopack_context__.v({
  "clickable": "DataTable-module__tlnGwW__clickable",
  "row": "DataTable-module__tlnGwW__row",
});
